<template>
  <!-- eslint-disable vue/no-v-html -->
  <!--
    Layout is organized in 3 columns and a topbar
     __________________________________
    |      Top bar with stats          |
    |__________________________________|
     _________  _______________  ______
    |         ||               ||      |
    | Project ||  All other    || Feed |
    |  Card   ||    cards      ||      |
    |         ||               ||      |
    |_________||_______________||______|
  -->

  <v-layout
    row
    wrap
  >
    <!-- Top bar -->
    <v-flex
      v-if="false"
      xs12
    >
      <v-layout
        row
        wrap
      >
        <router-link
          class="project-header__link xl4 md2 xs6 flex"
          tag="div"
          :to="{ name: 'project-expenses', params: { id: projectId } }"
        >
          <div
            class="display-2 font-weight-thin"
            v-html="$options.filters.fmtCurrency(project.estimateAtCompletion, { avg: true })"
          />
          <div class="text-uppercase subheading grey--text">
            Expenses
          </div>
        </router-link>

        <router-link
          class="project-header__link xl4 md2 xs6 flex"
          tag="div"
          :to="{ name: 'project-activities', params: { id: projectId } }"
        >
          <div class="display-2 font-weight-thin">
            {{ project.progress || 0 }}<sup>%</sup>
          </div>
          <div class="text-uppercase subheading grey--text">
            Progress
          </div>
        </router-link>
      </v-layout>
    </v-flex>

    <!-- Project card - left column -->
    <v-flex
      lg3
      md4
      sm6
      xs12
    >
      <v-card>
        <vu-carousel
          v-if="false"
          :images="project.images"
          :duration="8000"
        />

        <span
          v-if="false"
          class="headline has-shadow-bg"
        >{{ project.name }}</span>

        <v-card-title primary-title>
          {{ project.name }}
        </v-card-title>

        <v-card-text v-show="project.description">
          {{ project.description }}
        </v-card-text>

        <v-list
          v-if="customProperties('project').length"
          two-line
          subheader
        >
          <v-list-item
            v-for="customProp in customProperties('project')"
            :key="`custom-prop-${customProp.id}`"
          >
            <v-list-item-content>
              <v-list-item-title>{{ project[customProp.key] || '-' }}</v-list-item-title>
              <v-list-item-subtitle>{{ customProp.name }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-card-text>
          <project-team :project="project" />
        </v-card-text>
      </v-card>
    </v-flex>

    <!-- All other cards - central column -->
    <v-flex
      xl7
      lg6
      md4
      sm6
      xs12
    >
      <v-layout
        row
        wrap
      >
        <v-flex
          xl3
          lg6
          xs12
        >
          <project-activities-summary :project-id="projectId" />
        </v-flex>

        <v-flex
          xl3
          lg6
          xs12
        >
          <project-documents-summary
            v-if="false"
            :project="project"
          />
        </v-flex>

        <!-- Custom widgets from extensions -->
        <v-flex
          v-for="(widget, i) in extensionsWidgets"
          :key="`widget-${i}`"
          xl3
          lg4
          md4
          sm6
          xs12
        >
          <component :is="widget" />
        </v-flex>
      </v-layout>
    </v-flex>

    <!-- Project Feed - right column -->
    <v-flex
      xl2
      lg3
      md4
      sm6
      xs12
    >
      <project-feed
        v-if="false"
        :project="project"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

import { healthColorsText } from '@/config/projects'
import ProjectComponent from '@/mixins/ProjectComponent'
import HasWidgets from '@/mixins/HasWidgets'
import VuFileUpload from '@/components/shared/VuFileUpload'
import ProjectTeam from './ProjectTeam'
import ProjectCard from './ProjectCard'
import ProjectFeed from './ProjectFeed'
import HealthMicroChart from './HealthMicroChart'
import ProjectActivitiesSummary from './ProjectActivitiesSummary'
import ProjectDocumentsSummary from './ProjectDocumentsSummary'
import VuCarousel from '@/components/shared/VuCarousel'

export default {
  name: 'ProjectDetails',
  components: {
    HealthMicroChart,
    ProjectActivitiesSummary,
    ProjectCard,
    ProjectDocumentsSummary,
    ProjectFeed,
    ProjectTeam,
    VuCarousel,
    VuFileUpload
  },
  mixins: [ ProjectComponent, HasWidgets ],
  computed: {
    ...mapGetters('organizations', [ 'customProperties' ]),
    healthColor () {
      return this.project.health ? healthColorsText[this.project.health[0]] : null
    }
  }
}
</script>

<style lang="scss">
.project-header {
  &__link {
    border-bottom: 2px solid transparent;
    text-align: center;
    cursor: pointer;

    &:hover {
      border-bottom-color: rgba(0,0,0,0.87);
      background: #f2f2f2;
    }
  }
}

.has-shadow-bg {
  position: absolute;
  top: 0;
  left: 0;
  color: white;
  width: 100%;
  padding: 10px;
  background: linear-gradient(#6f6f6f, transparent);
}

.health-heart {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  text-shadow:
    2px 2px 0px #fafafa,
    -2px 2px 0px #fafafa,
    2px -2px 0px #fafafa,
    -2px -2px 0px #fafafa;
}
</style>
